module.exports = __webpack_public_path__ + "static/media/F4.02f26799.jpg";